<template>
    <div class="publicMain">
        <!-- 模糊查询 -->
        <!--    <div class="childrenFileSelect">-->
        <!--      <el-form :inline="true" :model="form" class="demo-form-inline">-->
        <!--        <el-form-item label="设备名称">-->
        <!--          <el-input v-model="form.name"></el-input>-->
        <!--        </el-form-item>-->
        <!--        <el-form-item label="IP地址">-->
        <!--          <el-input v-model="form.name"></el-input>-->
        <!--        </el-form-item>-->
        <!--        <el-form-item>-->
        <!--          <el-button type="primary" @click="onCheck">查询</el-button>-->
        <!--        </el-form-item>-->
        <!--        <el-form-item>-->
        <!--          <el-button type="info" @click="onReset">重置</el-button>-->
        <!--        </el-form-item>-->
        <!--      </el-form>-->
        <!--    </div>-->
        <div class="box">
            <el-row>
                <el-col :span="8">
                    <div class="echerts">
                        <div class="charts-title">床位统计</div>
                        <div ref="chart" id="chart" style="width:100%;height:100% "></div>
                    </div>
                </el-col>
                <el-col :span="16" class="box-font">
                    <h1>{{bed}}床位</h1>
                    <h1 style="margin-top: 100px">{{bedNumber}}</h1>
                </el-col>
            </el-row>
        </div>


        <!-- 新增按钮 -->
        <!--    <div class="add">-->
        <!--      <el-button type="primary" @click="add" size="add">新增</el-button>-->
        <!--    </div>-->
        <!-- 表格 -->
        <!--    <div class="table">-->
        <!--      <el-table :data="tableData" border style="width: 100%">-->
        <!--        <el-table-column type="index" width="50" label="序号" header-align="center" align="center"></el-table-column>-->
        <!--        <el-table-column-->
        <!--          v-for="(item,index) in tableColumn"-->
        <!--          :key="index"-->
        <!--          :prop="item.prop"-->
        <!--          :label="item.label"-->
        <!--          header-align="center"-->
        <!--        >-->
        <!--          <template slot-scope="scope">-->
        <!--            <div v-if="item.type=='button'" style="display:flex;justify-content: center;">-->
        <!--              <el-tooltip class="item" effect="light" content="查看" placement="top-start">-->
        <!--                <button class="iconfont icon-chakan tabBtn" @click="check(scope.row)"></button>-->
        <!--              </el-tooltip>-->
        <!--              <el-tooltip class="item" effect="light" content="修改" placement="top-start">-->
        <!--                <button class="iconfont icon-bianji3 tabBtn" @click="compile(scope.row)"></button>-->
        <!--              </el-tooltip>-->
        <!--              <el-tooltip-->
        <!--                class="item"-->
        <!--                style="color:#dd3020;"-->
        <!--                effect="light"-->
        <!--                content="删除"-->
        <!--                placement="top-start"-->
        <!--              >-->
        <!--                <button class="iconfont icon-icon7 tabBtn" @click="remove(scope.row)"></button>-->
        <!--              </el-tooltip>-->
        <!--            </div>-->
        <!--            <div v-else-if="item.type=='state'">-->
        <!--              <div style="text-align:center;">-->
        <!--                <el-tag v-if="scope.row.state==1">待审核</el-tag>-->
        <!--                <el-tag v-if="scope.row.state==2" type="success">通过</el-tag>-->
        <!--                <el-tag v-if="scope.row.state==3" type="danger">不通过</el-tag>-->
        <!--              </div>-->
        <!--            </div>-->
        <!--            <div v-else-if="item.type=='sex'">-->
        <!--              <div style="text-align:center;">-->
        <!--                <span v-if="scope.row.sex==0" type="success">男</span>-->
        <!--                <span v-if="scope.row.sex==1" type="primary">女</span>-->
        <!--              </div>-->
        <!--            </div>-->
        <!--            <div v-else-if="item.type=='nature'">-->
        <!--              <div style="text-align:center;">-->
        <!--                <el-tag v-if="scope.row.nature==1" type="success">农村户口</el-tag>-->
        <!--                <el-tag v-if="scope.row.nature==2" type="warning">城镇户口</el-tag>-->
        <!--                <el-tag v-if="scope.row.nature==3" type="danger">无户口</el-tag>-->
        <!--              </div>-->
        <!--            </div>-->
        <!--            <div-->
        <!--              v-else-->
        <!--              :style="{'text-align':item.align?item.align:'center'}"-->
        <!--            >{{scope.row[item.prop]}}</div>-->
        <!--          </template>-->
        <!--        </el-table-column>-->
        <!--      </el-table>-->
        <!--    </div>-->
        <!-- 分页 -->
        <!--    <div class="pagination">-->
        <!--      <el-pagination-->
        <!--        @size-change="handleSizeChange"-->
        <!--        @current-change="handleCurrentChange"-->
        <!--        :current-page="currentPage"-->
        <!--        :page-sizes="[10, 20, 50, 100]"-->
        <!--        :page-size="10"-->
        <!--        layout="total, sizes, prev, pager, next, jumper"-->
        <!--        :total="total"-->
        <!--      ></el-pagination>-->
        <!--    </div>-->
        <!-- 弹窗 -->
        <!--        <el-dialog :title="title" :visible.sync="visible" width="40%">-->
        <!--            <div style="width:100%; width: 90%;margin: 0px auto;">-->
        <!--                <el-form-->
        <!--                        v-if="visible"-->
        <!--                        :model="ruleForm"-->
        <!--                        :rules="rulesDialog"-->
        <!--                        ref="ruleForm"-->
        <!--                        label-width="100px"-->
        <!--                        class="demo-ruleForm"-->
        <!--                >-->
        <!--                    <el-form-item label="设备名称" prop="name">-->
        <!--                        <el-input v-model="ruleForm.name" style="width:90%"></el-input>-->
        <!--                    </el-form-item>-->
        <!--                    <el-row>-->
        <!--                        <el-col :span="11">-->
        <!--                            <el-form-item label="IP地址">-->
        <!--                                <el-input v-model="form.name"></el-input>-->
        <!--                            </el-form-item>-->
        <!--                            <el-form-item label="用户名">-->
        <!--                                <el-input v-model="form.name"></el-input>-->
        <!--                            </el-form-item>-->
        <!--                        </el-col>-->
        <!--                        <el-col :span="2" style="text-align:center"></el-col>-->
        <!--                        <el-col :span="11">-->
        <!--                            <el-form-item label="用户名">-->
        <!--                                <el-input v-model="form.name"></el-input>-->
        <!--                            </el-form-item>-->
        <!--                            <el-form-item label="密码">-->
        <!--                                <el-input v-model="form.name"></el-input>-->
        <!--                            </el-form-item>-->
        <!--                        </el-col>-->
        <!--                    </el-row>-->
        <!--                    <div class="button">-->
        <!--                        <div class="button-mid">-->
        <!--                            <el-button type="primary" @click="save">确定</el-button>-->
        <!--                            <el-button type="info" @click="visible=false">返回</el-button>-->
        <!--                        </div>-->
        <!--                    </div>-->
        <!--                </el-form>-->
        <!--            </div>-->
        <!--        </el-dialog>-->
    </div>
</template>

<script>
    import {
        getAllChildrenPolicyList,
        childrenHomePolicyEdit,
        childrenHomePolicyDelete,
        helpManageFamilyLogList,

        helpListOut, organizationInfoCheck
    } from "../api";
    //救助管理
    import request from "@/utils/request.js";

    import upload from "@/component/componentsP/upImg.vue";

    export default {
        components: {
            upload
        },
        data() {
            return {
                currentPage: 1, //默认展示第一页
                title: "", //dialog的标题
                visible: false, //dialog的标题
                //模糊查询数据
                form: {},
                fileList: [],
                typeImg: "",
                visibleShow: false, //
                //table表格的column
                tableColumn: [
                    {
                        prop: "name",
                        label: "设备名称"
                    },
                    {
                        prop: "rescueName",
                        label: "IP地址"
                    },
                    {
                        prop: "money",
                        label: "端口"
                    },

                    {
                        label: "操作",
                        type: "button"
                    }
                ],
                //table表格的数据
                tableData: [],
                buttonType: false,
                row: {},
                total: 0, //总数据
                pageNo: 1,
                pageSize: 10,
                ruleForm: {},
                rulesDialog: {},
                bed: '已经入住床位',
                bedNumber: 100,
            };
        },
        methods: {
            //查询
            onCheck() {
                this.getAllChildrenPolicyListAPI({
                    pageNo: this.pageNo,
                    pageSize: this.pageSize,
                    ...this.form
                });
                this.$message({
                    message: "查询成功",
                    type: "success"
                });
            },
            //重置
            onReset() {
                this.form = {};
                this.getAllChildrenPolicyListAPI({
                    pageNo: this.pageNo,
                    pageSize: this.pageSize
                });
                this.$message({
                    message: "重置成功",
                    type: "success"
                });
            },
            //每页请求${val}条数据
            handleSizeChange(val) {
                this.pageSize = val;
                this.getAllChildrenPolicyListAPI();
                this.$message({
                    message: `每页请求${val}条数据成功`,
                    type: "success"
                });
            },
            //请求第${val}页数据
            handleCurrentChange(val) {
                this.pageNo = val;
                this.getAllChildrenPolicyListAPI();
                this.$message({
                    message: `请求第${val}页数据成功`,
                    type: "success"
                });
            },
            //新增
            add(e) {
                this.bed = e.data.name
                this.bedNumber = e.value
                // this.visible = true
            },
            //
            getEchartData() {
                // const chart = this.$refs.chart;
                console.log('chart', chart);
                let that = this
                const myChart = this.$echarts.init(document.getElementById("chart"));
                myChart.on("click", this.add);
                const option = {
                    title: {
                        text: "",
                        subtext: "",
                        left: "center",
                    },
                    tooltip: {
                        trigger: "item",
                        formatter: "{a} <br/>{b} : {c} ({d}%)",
                    },
                    legend: {
                        orient: "vertical",
                        left: "left",
                        data: ["直接访问", "邮件营销", "联盟广告", "视频广告", "搜索引擎"],
                    },
                    series: [
                        {
                            name: "访问来源",
                            type: "pie",
                            radius: "55%",
                            center: ["50%", "60%"],
                            data: [
                                {
                                    value: that.form.reserveds,
                                    name: "已预约",
                                    itemStyle: {color: "rgb(251,212,55)"},
                                },
                                {
                                    value: Number(that.form.beds) - Number(that.form.checks) - Number(that.form.reserveds),
                                    name: "未入住",
                                    itemStyle: {color: "rgb(78,203,115)"},
                                },
                                {
                                    value: that.form.checks,
                                    name: "已入住",
                                    itemStyle: {color: "rgb(240,72,100)"},
                                },

                            ],
                            emphasis: {
                                itemStyle: {
                                    shadowBlur: 10,
                                    shadowOffsetX: 0,
                                    shadowColor: "rgba(0, 0, 0, 0.5)",
                                },
                            },
                        },
                    ],
                };
                this.bed = option.series[0].data[0].name
                this.bedNumber = option.series[0].data[0].value
                myChart.setOption(option);
                window.addEventListener("resize", function () {
                    myChart.resize();
                });

                this.$on("hook:destroyed", () => {
                    window.removeEventListener("resize", function () {
                        myChart.resize();
                    });
                });
            },
            //回写拿到数据
            getData(e) {
                organizationInfoCheck(e).then(res => {
                    this.form = res.content;
                    this.$nextTick(() => {
                        setTimeout(() => {
                            this.getEchartData();
                        }, 500);
                    });
                });
            },

        },
        created() {
            this.query = {
                id: this.$route.query.id,
                buttonType: this.$route.query.buttonType,
                row: JSON.parse(this.$route.query.row),
            };
            this.getData({id: this.query.id});

        }
    };
</script>

<style lang="less" scoped>
    .publicMain {
        background-color: #fff;
        padding: 16px;
        box-sizing: border-box;
        width: 100%;
        height: 100%;

    }

    // 面包屑导航box
    .mianbao {
        box-sizing: border-box;
        margin: -16px -16px 0;
        background-color: #eef1f6;
        height: 47px;
        align-items: center;
        padding-left: 16px;
        margin-bottom: 16px;
    }

    .childrenFileSelect {
        border: 1px solid rgb(230, 230, 230);
        padding: 20px;
    }

    .table {
        margin: 20px 0px;
    }

    .slot {
        width: 90%;
        height: 500px;
        overflow: auto;
        margin: auto;
    }

    .add {
        margin: 20px 0px;
    }

    .left {
        width: 45%;
        display: inline-block;
    }

    .right {
        width: 50%;
        display: inline-block;
        float: right;
    }

    .el-form-item__label {
        line-height: 20px !important;
    }

    .el-form-item {
        margin-bottom: 20px !important;
    }

    .el-radio {
        margin: 10px;
    }

    .button-mid {
        width: 300px;
        margin: 30px auto;
        display: flex;
        justify-content: space-between;
    }

    .echerts {
        width: 100%;
        height: 500px;
        margin: 30px auto 0px;
    }

    .charts-title {
        font-weight: 700;
        border-bottom: 1px solid rgb(200, 200, 200);
        margin-left: 52px;
        padding-bottom: 20px;
    }

    .box {
        width: 100%;
        height: 500px;

    }

    .box-font {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        height: 500px;
    }
</style>
